import { render, staticRenderFns } from "./zhuce.vue?vue&type=template&id=80cebfbc&scoped=true"
import script from "./zhuce.vue?vue&type=script&lang=js"
export * from "./zhuce.vue?vue&type=script&lang=js"
import style0 from "./zhuce.vue?vue&type=style&index=0&id=80cebfbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cebfbc",
  null
  
)

export default component.exports